export class ParametriStampa {
  oggetto: string;
  luogo: string;
  paragrafo1: string;
  paragrafo2: string;
  paragrafo3: string;
  paragrafo4: string;
  paragrafo5: string;
  footer1: string;
  footer2: string;
  footer3: string;
  headerFileName: string;
  firmaTimbroFileName: string;
  logoFileName: string;
  headerBase64: string;
  firmaTimbroBase64: string;
  logoBase64: string;
}